// extracted by mini-css-extract-plugin
export default {"logoutButton":"Header_logoutButton__q3GOk"};